import React from "react";
import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import KanbanCardComment from "./KanbanCardComment";
import { useTranslation } from "react-i18next";

const KanbanCardCommentSection = (props) => {

    const { t } = useTranslation();

    return (
        <>
            <Stack>
                {props.comments.map((comment, index) => {
                    return <KanbanCardComment 
                    id={index} key={index}
                    comment={comment} 
                    cardId={props.cardId} 
                    columnId={props.columnId} 
                    editComment={props.editComment}
                    deleteComment={props.deleteComment} />
                })}
            </Stack>
        </>
    );
};

KanbanCardCommentSection.propTypes = {
    cardId: PropTypes.string, 
    columnId: PropTypes.number,
    comments: PropTypes.array,
    editComment: PropTypes.func,
    deleteComment: PropTypes.func
};

export default KanbanCardCommentSection;